import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { LOGIN_ROUTE } from "../../config/RoutesConstants"
import { 
  Container, 
  Box, 
  Button,
  Collapse,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  IconButton,
  InputLabel,
  Fab,
  FormControl,
  Grid,
  GridList,
  GridListTile,
  Paper,
  Typography, 
  Tooltip,
  Input,
  Icon,
  Toolbar,
  MenuItem,  
  Select,
  Tab,
  Tabs,
  Table,
  TableRow,
  TableCell,
  TableSortLabel,
  TableHead,
  TableBody,
  TablePagination,
  TextField

} from "@material-ui/core"
import { withTheme } from "@material-ui/core/styles"
import BackIcon from '@material-ui/icons/ArrowBackRounded';
import ArrowRightIcon from '@material-ui/icons/ChevronRight'
import ArrowDownIcon from '@material-ui/icons/ArrowDropDown'
import ArrowUpIcon from '@material-ui/icons/ArrowDropUp'
import Util, { ERROR, SUCCESS } from '../../common/Util'
import Settings from "../../provider/base/Settings"
import { actionGetStatsByRRPPDetail } from "../../actions/StatsActions"

import moment from "moment"

import SearchIcon from '@material-ui/icons/Search';
// import ClearIcon from '@material-ui/icons/Backspace';
import RefreshIcon from '@material-ui/icons/Sync';
import DetailIcon from '@material-ui/icons/List';

class StatsByRRPPDetail extends React.PureComponent{
  constructor(props){
    super(props)
    let lastMonth = moment()
    lastMonth = lastMonth.add(-1,"month").format("YYYY-MM-DD")
    let today = moment().format("YYYY-MM-DD")
    let filter = props.filter||{from:lastMonth, to:today, period:"daily", place:""}
    this.state = {count:0, rowPerPage:10, page:1, orderBy:"Qt", orderDesc:true, filter:filter, tabIndex:0, openDetail:{}}
    this.renderTableHeader=this.renderTableHeader.bind(this)
    this.renderTableBody=this.renderTableBody.bind(this)
    this.onRefresh = this.onRefresh.bind(this)
    this.sortStatsByRRPPDetail = this.sortStatsByRRPPDetail.bind(this)
    this.onFilterDate = this.onFilterDate.bind(this)
    this.onChangePage = this.onChangePage.bind(this)
    this.onChangeRowsPerPage = this.onChangeRowsPerPage.bind(this)
    this.onSortByField = this.onSortByField.bind(this)
    this.onClose = this.onClose.bind(this)
  }

  getStatsByRRPPDetailError(e){
    console.log("ERROR GET STATS BY RRPP Detail", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al listar las estadísticas por cliente.")
  }

  onRefresh(){
    const {orderBy, orderDesc, filter} = this.state
    const {user} = this.props
    let order = {orderBy:orderBy, orderDesc:orderDesc}
    this.props.actionGetStatsByRRPPDetail({...filter, tktRrpp:user.tktRrpp}, order, this.onChangePage, this.getStatsByRRPPDetailError)
  }

  onSortByField(field){
    if(field == this.state.orderBy){
      this.setState({orderDesc:!this.state.orderDesc}, this.onChangePage)
    }else{
      this.setState({orderBy:field}, this.onChangePage)
    }
  }

  onChangePage(evt=null, newPage=0){
    let from=newPage*this.state.rowPerPage
    let end=from+this.state.rowPerPage
    let users = this.props.statsByRRPPDetail //.filter(this.filterUsers)
    
    const count = users.length
    users = users.sort(this.sortStatsByRRPPDetail)
    users = users.slice(from, end)
    this.setState({page:newPage, count:count, users:users})
  }

  onChangeRowsPerPage(evt){
    let from=this.state.page*evt.target.value
    let end=from+evt.target.value
    let users = this.props.statsByRRPPDetail //.filter(this.filterUsers)
    const count = users.length
    users = users.sort(this.sortStatsByRRPPDetail)
    users = users.slice(from, end)
    this.setState({rowPerPage:evt.target.value, users:users})
  }

  sortStatsByRRPPDetail(a,b){
    try{
      if(this.state.orderDesc){
        return b[this.state.orderBy] - a[this.state.orderBy]
      }
      return a[this.state.orderBy] - b[this.state.orderBy]
    }catch(e){
      console.log("SORT STATS BY RRPP ERROR", e)
      return -1
    }
  }

  onChangeFilter(field, evt){
    let filter = {...this.state.filter}
    filter[field] = evt.target.value
    this.setState({filter:filter})
  }

  onFilterDate(){
    if(this.state.filter&&this.state.filter.from&&this.state.filter.to){
      this.onRefresh()
    }
  }

  onOpenDetail(evtId){
    let openDetail = {...this.state.openDetail}
    openDetail[evtId] = openDetail[evtId]?false:true
    this.setState({openDetail:openDetail})
  }

  renderTableHeader(){
    const {theme} = this.props
    const headers = [{id:"evtId",label:"Evento"}, 
                    //  {id:"tktType",label:"Tipo de Ticket"},
                     {id:"Qt", label:"Cantidad"},
                     {id:"Total", label:"Total $"},
                     {id:"TotalProducer", label:"Total $ Productor"}]
                     
    // if(Settings.IS_USER_VERIFIED){
    //   headers.splice(1,0,{id:"proInstagram",label:"Instagram"})

    // }
    return (
    <TableRow>
      {headers.map((headCell,i)=>{
        if(headCell.id == "evtId"){
          return (
            <TableCell> {headCell.label}</TableCell>
          )
        }
        return (
          <TableCell>
            <TableSortLabel
            active={this.state.orderBy === headCell.id}
            direction={this.state.orderBy === headCell.id && this.state.orderDesc ? 'desc' : 'asc'}
            onClick={()=>this.onSortByField(headCell.id)}
            hideSortIcon={true}>
              {headCell.label}
            </TableSortLabel>  
          </TableCell>
        )
      })}
    </TableRow>
    )
  }

  renderTableBody(){
    const {theme, statsByRRPPDetail} = this.props
    const { openDetail } = this.state
    if(!statsByRRPPDetail||statsByRRPPDetail.length==0){
      return <Box style={theme.table.empty}>No se encontraron registros</Box>
    }
    return statsByRRPPDetail.map((item, index)=>{
      const isOpen = openDetail[item.evtId]
      return (
        [<TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
          <TableCell>
            <Button startIcon={isOpen?<ArrowUpIcon/>:<ArrowDownIcon/>} onClick={this.onOpenDetail.bind(this, item.evtId)}>{item.evtName}</Button></TableCell>
          <TableCell>{item.evtQt}</TableCell>
          <TableCell>{Util.formatCurrency(item.evtTotal)}</TableCell>
          <TableCell>{Util.formatCurrency(item.evtTotalProducer)}</TableCell>
          
        </TableRow>,
        <TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
          <TableCell colSpan={4}>
            <Collapse in={isOpen} timeout="auto" unmountOnExit style={{aligItems:"center"}}>
              <Table stickyHeader style={{marginLeft:20, marginRight:8, width:"100%"}}>
                  <TableHead > 
                    {this.renderTableHeaderDetail()}
                  </TableHead>
                  <TableBody>
                    {this.renderTableBodyDetail(item.tktTypeData)}
                  </TableBody>
                </Table> 
            </Collapse>
          </TableCell>
        </TableRow>
        ]
      )
    })
  }

  renderTableHeaderDetail(){
    const {theme} = this.props
    const headers = [{id:"id",label:"Tipo de Ticket"}, 
                     {id:"Qt", label:"Cantidad"},
                     {id:"Total", label:"Total $"},
                     {id:"TotalProducer", label:"Total $ Productor"}]
    return (
    <TableRow>
      {headers.map((headCell,i)=>{
          return (
            <TableCell> {headCell.label}</TableCell>
          )
      })}
    </TableRow>
    )
  }
  
  renderTableBodyDetail(detail){
    const {theme} = this.props
    if(!detail||detail.length==0){
      return <Box style={theme.table.empty}>No se encontraron registros</Box>
    }
    return detail.map((item, index)=>{
      return (
        <TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
          <TableCell>{`${item.tktCategory} - ${item.tktName}`}</TableCell>
          <TableCell>{item.Qt}</TableCell>
          <TableCell>{Util.formatCurrency(item.Total)}</TableCell>
          <TableCell>{Util.formatCurrency(item.TotalProducer)}</TableCell>
        </TableRow>
      )
    })
  }

  onClose(){
    this.setState({openDetail:{}})
    this.props.onClose()
  }

  render(){
    const { theme, handleSubmit, history, user} = this.props
    const { filter } = this.state
    return (
        <Dialog open={user?true:false} onClose={this.onClose} >
          <DialogTitle>{user&&user.rrpp?`Detalle de ${user.rrpp.lastname}, ${user.rrpp.name}`:""}</DialogTitle>
          <Toolbar style={{...theme.table.toolbar, justifyContent:"space-between"}} >
                <TextField
                    value={filter.from}
                    label="Fecha desde"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    onChange={this.onChangeFilter.bind(this,"from")}
                  />  
                 <TextField
                    value={filter.to}
                    label="Fecha hasta"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    onChange={this.onChangeFilter.bind(this,"to")}
                  />  
                <IconButton onClick={this.onFilterDate}>
                <SearchIcon/>
              </IconButton>
          </Toolbar>
          <Table stickyHeader>
            <TableHead > 
              {this.renderTableHeader()}
            </TableHead>
            <TableBody>
              {this.renderTableBody()}
            </TableBody>
          </Table> 
        </Dialog>
    )
  }
}
function mapStateToProps(store) {
  return {
    login: store.auth.login,
    statsByRRPPDetail:store.stats.statsByRRPPDetail
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetStatsByRRPPDetail
    },
    dispatch
  );
}

// StatsByRRPPDetail.defaultProps = {
//   stats:{
//     statsTotalQtSell:50,
//     statsTotalQt:1000,
//     statsTotalAmmountProducer:22000,
//     statsTotalAmmount:27000,
//     statsTotalQtSellByRRPP:1100 //transient
//   }
// }

export default withRouter(
    withTheme(
      connect(
        mapStateToProps,
        mapDispatchToProps
      )(StatsByRRPPDetail)
    )
  )


// WEBPACK FOOTER //
// ./src/screens/statistics/StatsByRRPPDetail.js